import { InspectionTranslationKeys } from 'intl/keys';
import { TranslationKey } from 'intl/types/translationKey';
import { InspectionStatus } from 'shared/domain/inspection/inspectionModel';

const INSPECTION_STATUS_LABEL_KEYS: Record<InspectionStatus, TranslationKey> = {
  [InspectionStatus.inProgress]: InspectionTranslationKeys.statusInProgress,
  [InspectionStatus.completed]: InspectionTranslationKeys.statusCompleted,
};

export function inspectionStatusLabelKey(
  status: InspectionStatus
): TranslationKey {
  return INSPECTION_STATUS_LABEL_KEYS[status];
}
